import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-radio-button',
  templateUrl: './radio-button.component.html',
  styleUrls: ['./radio-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: RadioButtonComponent,
      multi: true
    }
  ]
})
export class RadioButtonComponent implements OnInit, ControlValueAccessor  {

  @Input()
  labelText: string;

  @Input()
  optionOne: string;

  @Input()
  optionTwo: string;

  model: boolean | undefined;

  @Input()
  required: boolean;

  @Input()
  submitted: boolean;

  warningLabel: string;
  dateModel: boolean | undefined;
  onChange!: (value: any) =>  void;

  constructor(private rf: ChangeDetectorRef) {
    this.labelText = '';
    this.optionOne = '';
    this.optionTwo = '';
    this.required = false;
    this.submitted = false;
    this.warningLabel = '';
   }

   writeValue(obj: any): void {
    this.dateModel = obj;
    this.rf.detectChanges();
  }
  registerOnChange(fn: any): void {
    console.log('registerOnChange', fn)
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
  }
  
  setDisabledState?(isDisabled: boolean): void {
  }

  onSelectionChange(value: boolean): void {
    this.dateModel = value;
    this.onChange(this.dateModel);
  }

  ngOnInit(): void {
  }

  validate(): boolean {

    if (!this.submitted) {
      return true;
    }

    if (this.required && !this.dateModel) {
      this.warningLabel = `Ingrese su ${this.labelText}.`;
      return false;
    }

    return true;
  }

}
